import React from 'react';
import "../App.css";
import WhyChooseUs from "../Components/WhyChooseUs";

import LuxuryImage1 from "../image/LuxuryImage1.webp";
import LuxuryImage2 from "../image/LuxuryImage2.webp";
import ManufacturingUnit from "../image/ManufacturingUnit.webp";

export default function AboutPage() {
  return (
    <div className="page-wrapper light-section min-vh-100">
      {/* Hero Banner Section */}
      <div className="page-banner position-relative">
        <div className="glowing-orb primary top-50 start-50 translate-middle" style={{ width: '400px', height: '400px', opacity: 0.5 }}></div>
        <div className="container position-relative z-1">
          <h1 className="page-banner-title text-white">About Us</h1>
          <div className="page-banner-breadcrumb text-light opacity-75">
            <a href="/" className="text-light">Home</a> <span>/</span> About Us
          </div>
        </div>
      </div>

      <section className="section-padding light-section">
        <div className="container position-relative z-1">
          <div className="row align-items-center mb-5">
            <div className="col-lg-6 mb-4 mb-lg-0 pe-lg-5 text-center text-lg-start px-3 px-md-4 px-lg-3">
              <span className="section-pill mb-3">SHREE KAMDHENU FURNITURE</span>
              <h2 className="section-heading text-dark mb-3 mb-md-4 fs-3 fs-md-2">Our <span className="text-primary fst-italic">Journey</span></h2>
              <h5 className="font-serif text-muted-dark mb-4 mb-md-5 text-uppercase" style={{ letterSpacing: '2px', fontSize: '14px' }}>Company History & Facts</h5>

              <div className="border-start border-4 border-primary ps-3 ps-md-4 mb-4 mb-md-5 text-start mx-auto mx-lg-0" style={{ maxWidth: '600px' }}>
                <p className="text-dark mb-3 fs-6 fs-md-5 font-serif" style={{ lineHeight: '1.8' }}>
                  Established in the year 1998, <strong>Shree Kamdhenu Furniture</strong> (Khodiyar Fabrication) is a notable and prominent firm engaged as a manufacturer and wholesale trader of premium steel beds, box beds, laser CNC cupboards, and heavy-duty almirahs.
                </p>
                <p className="text-muted-dark mb-0" style={{ lineHeight: '1.8', fontSize: '0.95rem' }}>
                  Located in Surat (Gujarat), our state-of-the-art infrastructural unit assists us in manufacturing high-quality products. Under the mentorship of Mr. Rakshit Sakariya, we deliver robust designs, excellent strength, and high durability to our clients across the nation. We are also a trusted supplier on IndiaMart.
                </p>
              </div>

              <div className="d-flex flex-wrap gap-3 justify-content-center justify-content-lg-start mt-4">
                <a href="/contact" className="btn btn-primary rounded-pill px-4 py-2 hover-lift shadow-sm">CONTACT US</a>
                <a href="/collections" className="btn btn-outline-dark rounded-pill px-4 py-2 hover-lift">OUR PRODUCTS</a>
              </div>
            </div>
            <div className="col-lg-6 mt-4 mt-lg-0 py-4 py-lg-5 px-2 px-md-5">
              <div className="position-relative mx-auto" style={{ maxWidth: '520px' }}>
                {/* Main Image */}
                <img src={LuxuryImage1} alt="Factory" className="img-fluid rounded-4 shadow-lg position-relative z-1" style={{ width: '85%', objectFit: 'cover', aspectRatio: '4/5' }} />

                {/* Overlapping Image */}
                <img src={LuxuryImage2} alt="Office" className="img-fluid rounded-4 shadow-lg position-absolute" style={{ width: '55%', bottom: '-5%', right: '0', border: '6px solid var(--bg-light)', zIndex: 2, objectFit: 'cover', aspectRatio: '4/3' }} />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Banner */}
      <section className="stats-banner py-4 py-md-5" style={{
        background: `linear-gradient(rgba(198, 40, 40, 0.85), rgba(198, 40, 40, 0.95)), url(${ManufacturingUnit})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}>
        <div className="container position-relative z-1">
          <div className="row mx-0 text-center border border-light border-opacity-25 p-3 p-md-4 rounded-4 stats-mobile-grid" style={{ background: 'rgba(0,0,0,0.1)' }}>
            <div className="col-md-3 col-6 border-end border-light border-opacity-25 mb-0">
              <h2 className="text-white fw-bold mb-1 fs-3 fs-md-2">32+</h2>
              <p className="text-white opacity-75 small mb-0">Year Of Experience</p>
            </div>
            <div className="col-md-3 col-6 border-md-end border-light border-opacity-25 mb-0">
              <h2 className="text-white fw-bold mb-1 fs-3 fs-md-2">500+</h2>
              <p className="text-white opacity-75 small mb-0">Happy Customers</p>
            </div>
            <div className="col-md-3 col-6 border-end border-light border-opacity-25 mb-0">
              <h2 className="text-white fw-bold mb-1 fs-3 fs-md-2">150+</h2>
              <p className="text-white opacity-75 small mb-0">Products</p>
            </div>
            <div className="col-md-3 col-6 mb-0">
              <h2 className="text-white fw-bold mb-1 fs-3 fs-md-2">25+</h2>
              <p className="text-white opacity-75 small mb-0">Industry Segment</p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Us Section */}
      <WhyChooseUs />
    </div>
  );
}
